import React from 'react';

export const PLATFORM_LABELS = {
  facebook: 'Facebook',
  instagram: 'Instagram',
  meta_ads: 'Meta Ads',
  google_ads: 'Google Ads',
};

const STATUS_STYLES = {
  pending_approval: 'bg-orange/15 text-orange border-orange/40',
  approved: 'bg-lime/15 text-lime border-lime/40',
  scheduled: 'bg-blue-500/15 text-blue-400 border-blue-500/40',
  published: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/40',
  rejected: 'bg-orange/15 text-orange border-orange/40',
  draft: 'bg-gray-500/15 text-gray-400 border-gray-500/40',
  launched: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/40',
};

export const StatusBadge = ({ status }) => (
  <span
    data-testid={`status-badge-${status}`}
    className={`px-2 py-0.5 rounded-full text-xs font-semibold border capitalize whitespace-nowrap ${STATUS_STYLES[status] || STATUS_STYLES.draft}`}
  >
    {(status || '').replace('_', ' ')}
  </span>
);

export const PlatformBadge = ({ platform }) => (
  <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-white/5 text-gray-light border border-divider whitespace-nowrap">
    {PLATFORM_LABELS[platform] || platform}
  </span>
);

export const formatDateTime = (iso) =>
  iso
    ? new Date(iso).toLocaleString([], { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
    : '';
